import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import { motion,AnimatePresence } from "framer-motion";

function Tofuemail() {
const [index, setIndex] = useState(0);
 const [showSuccessModal, setShowSuccessModal] = useState(false);
   const [formType, setFormType] = useState(""); // stores which button opened the form
 const [showModal, setShowModal] = useState(false);
   const [animate, setAnimate] = useState(false);
   const [loading, setLoading] = useState(false);
 const slides = [
    { text: "Email Marketing That Actually Works for You" },
    { text: "Plan, Send and Convert Emails into Sales" },
    { text: "Identify, Engage and Convert Prospects into Profit" },
  ];
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.5, // delay between each div
    },
  },
};

const handleContactChange = (e) => {
  const { name, value } = e.target;
  setContactForm((prev) => ({ ...prev, [name]: value }));
};
const openModal = () => {
  setShowModal(true);
  setTimeout(() => setAnimate(true), 10); // trigger fade-in animation
};
  // 🔹 Close modal
  const closeModal = () => {
    setAnimate(false);
    setTimeout(() => setShowModal(false), 300);
  };
const [contactForm, setContactForm] = useState({
  fullname: "",
  company: "",
  website: "",
  email: "",
  phone: "",
  message: "",
});
const isBusinessEmail = (email) => {
  const freeDomains = [
    "gmail.com",
    "yahoo.com",
    "hotmail.com",
    "outlook.com",
    "aol.com",
    "icloud.com",
    "mail.com",
    "live.com"
  ];
  const domain = email.split("@")[1]?.toLowerCase();
  if (!domain) return false;
  return !freeDomains.includes(domain);
};

const handleContactSubmit = async (e) => {
  e.preventDefault();
 setLoading(true); // show loading message
  const { fullname, company, website, email, phone, message} = contactForm;
  // Basic validation
  if (!fullname || !email || !message || !company || !phone || !website) {
    alert("Please fill all required fields.");
      setLoading(false); // show loading message

    return;
  }
if (!isBusinessEmail(email)) {
    alert("Please enter a business email, not Gmail/Yahoo/etc.");
      setLoading(false); // show loading message

    return;
  }
 

  try {
    try {
    const emailCheckResponse = await fetch(
      `https://pinakinedgemedia.com/api/validateEmail?email=${email}`
    );
    const emailCheckData = await emailCheckResponse.json();

    if (!emailCheckData.exists) {
      setLoading(false);
      alert("❌ The entered email does not exist. Please use a valid business email.");
      return;
    }
  } catch (err) {
    setLoading(false);
    console.error("Email check failed:", err);
    alert("⚠️ Could not verify email existence. Try again later.");
    return;
  }
    const response = await fetch("https://pinakinedgemedia.com/api/sendContactMail", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
  ...contactForm,
  formType, // ✅ add formType manually here
}),

    });

    if (response.ok) {
       setShowSuccessModal(true);  // ✅ This triggers modal to open
       setLoading(false); // show loading message
 closeModal();
       setContactForm({
        fullname: "",
        company: "",
        website: "",
        email: "",
        phone: "",
        message: "",
      });
    } else {
      alert("Error sending message.");
    }
  } catch (err) {
    console.error(err);
    alert("Error sending message.");
  }
};
// alternate slide: left for odd, right for even
const itemVariants = (direction = "left") => ({
  hidden: { opacity: 0, x: direction === "left" ? -50 : 50 },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 1.8, // slow fade + slide
      ease: "easeInOut",
    },
  },
});
   useEffect(() => {
    const timer = setInterval(() => {
      setIndex((prev) => (prev + 1) % slides.length);
    }, 4500);
    return () => clearInterval(timer);
  }, [slides.length]);

  const currentSlide = slides[index] ?? { text: "" };
  return (
    
    <div>
      <Header />
       <main>
    <AnimatePresence>
              {showSuccessModal && (
                <motion.div
                  className="modal-overlay show"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  exit={{ opacity: 0 }}
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background: "rgba(0,0,0,0.5)",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    zIndex: 9999,
                  }}
                >
                  <motion.div
                    className="modal show"
                    initial={{ scale: 0.8, opacity: 0 }}
                    animate={{ scale: 1, opacity: 1 }}
                    exit={{ scale: 0.8, opacity: 0 }}
                    transition={{ duration: 0.3 }}
                    style={{
                      background: "#fff",
                      padding: "30px",
                      borderRadius: "10px",
                      width: "400px",
                      textAlign: "center",
                      boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                    }}
                  >
                    <h2 style={{ fontSize: "20px", marginBottom: "10px" }}>
                      Message Sent!
                    </h2>
                    <p>Thank you for contacting us. We will get back to you shortly.</p>
                    <button className="vc rg lk gh ml il hi gi _l"
                      onClick={() => setShowSuccessModal(false)}
                     
                    >
                      Close
                    </button>
                  </motion.div>
                </motion.div>
              )}
            </AnimatePresence>
              {/* 🔹 Modal */}
                    {showModal && (
                      <div
                        className={`modal-overlay ${animate ? "show" : ""}`}
                        onClick={(e) => {
                          if (e.target.classList.contains("modal-overlay")) {
                            closeModal();
                          }
                        }}
                        style={{
                          position: "fixed",
                          top: 0,
                          left: 0,
                          right: 0,
                          bottom: 0,
                          background: "rgba(0, 0, 0, 0.5)",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          zIndex: 1000,
                          opacity: animate ? 1 : 0,
                          transition: "opacity 0.3s ease",
                        }}
                      >
                        <motion.div
                          className="modal-box"
                          initial={{ scale: 0.8, opacity: 0 }}
                          animate={{ scale: 1, opacity: 1 }}
                          exit={{ scale: 0.8, opacity: 0 }}
                          transition={{ duration: 0.3 }}
                          style={{
                            position: "relative",
                            background: "#fff",
                            padding: "30px",
                            borderRadius: "10px",
                            textAlign: "center",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
                          }}
                        >
                          {/* Close button */}
                          <button
                            onClick={closeModal}
                            style={{
                              position: "absolute",
                              top: "10px",
                              right: "15px",
                              background: "transparent",
                              border: "none",
                              fontSize: "22px",
                              cursor: "pointer",
                              color: "#333",
                            }}
                          >
                            ×
                          </button>
            
                          <h2 className="fk tj kk wm bb">
                           Contact Now
                          </h2>
                       <form onSubmit={(e) => handleContactSubmit(e)}>
      <div className="tc sf yo ap zf xi1">
        <div className="vd to/2">
          <input
            type="text"
            name="fullname"
            id="fullname"
            placeholder="Full name"
            value={contactForm.fullname}
            onChange={handleContactChange}
            className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
          />
        </div>
    
        <div className="vd to/2">
          <input
            type="text"
            name="company"
            id="company"
             placeholder="Company name"
            value={contactForm.company}
            onChange={handleContactChange}
            className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
          />
        </div>
      </div>
    
      <div className="tc sf yo ap zf xi1">
        <div className="vd to/2">
          <input
            type="text"
            name="website"
            id="website"
              placeholder="Website"
            value={contactForm.website}
            onChange={handleContactChange}
            className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
          />
        </div>
    
        <div className="vd to/2">
          <input
            type="email"
            name="email"
             placeholder="Email address"
            id="email"
            value={contactForm.email}
            onChange={handleContactChange}
            className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
          />
        </div>
      </div>
    
      <div className="tc sf yo ap zf xi1">
        <div className="vd to/2">
         <input
      type="text"
      name="phone"
      id="phone"
        placeholder="Phone number"
      value={contactForm.phone}
      onChange={(e) => {
        // Allow only digits
        const value = e.target.value.replace(/\D/g, "");
        setContactForm((prev) => ({ ...prev, phone: value }));
      }}
      maxLength={10} // optional: limit to 10 digits
      className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 xi1 mi"
    />
    
        </div>
      </div>
    
      <div className="fb">
        <textarea
          placeholder="Message"
          rows="3"
          name="message"
          id="message"
          value={contactForm.message}
          onChange={handleContactChange}
          className="vd ph sg zk xm _g ch pm hm dm dn em pl/50 ci"
        ></textarea>
      </div>
    
      <div className="tc xf">
          <button
      type="submit"
      className="vc rg lk gh ml il hi gi _l"
      disabled={loading}
    >
      {loading ? "Please wait..." : " Send Message"}
    </button>
    
      </div>
    </form>
                        </motion.div>
                      </div>
                    )}

 <section className="hero-section herovv1">
      <video
        className="hero-video"
        src="/images/Emailvideo.mp4"
        autoPlay
        muted
        loop
        loading="lazy"
        playsInline
      />

      <div className="hero-overlay" />

      <div className="hero-content">
        <div className="hero-inner">
          <AnimatePresence mode="wait">
            <motion.h1
              key={index}
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -30 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              className="setslidtext"
            >
              {currentSlide.text}
            </motion.h1>
          </AnimatePresence>
        </div>
      </div>
    </section>

     <section className="i ji ii">
       {/* Bg Shapes */}
      <span className="rc h s r vd fd/5 fh rm"></span>
      <img src="/images/shape-08.svg" alt="Shape Bg" className="h q r" />

      {/* Section Title */}
      <div className="animate_top bb ze rj ki xn vq">
        <motion.section
          initial={{ opacity: 0, y: 100 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
          transition={{
            duration: 1.8,
            ease: "easeOut",
            type: "spring",
            stiffness: 40,
            damping: 20,
          }}
        >
        <h2 className="fk vj pr kk wm on/5 gq/2 bb _b">
         Email Marketing
        </h2></motion.section>
        
      </div>
      <br/>
      <div className="container">
      <motion.section
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
        transition={{
          duration: 1.8,
          ease: "easeOut",
          type: "spring",
          stiffness: 40,
          damping: 20,
        }}
      >
        <div className="left">
          <img src="/images/email90.png" alt="Left Side" />
        </div>
</motion.section>
        {/* Right Side - Content */}
        <div className="right">
            <motion.section
              initial={{ opacity: 0, y: 100 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
              transition={{
                duration: 1.8,
                ease: "easeOut",
                type: "spring",
                stiffness: 40,
                damping: 20,
              }}
            >
        <h3 className="fk tj kk wm bb _b mk">Email Marketing That Converts, Not Just Delivers</h3>
          <p className="uo">
            Email nurturing isn't just dispatching messages — it's forging trust, orchestrating the lead’s path, and being a constant guide that offers insight, support, and value at every turn. We elevate campaigns by weaving your brand’s story with crafted care. From writing each email with finesse to tracking impact through opens and engagement — we do nurturing with laser-focus, grace, and genuine personalization.
         </p>
       
           <div className="tc tf yo zf mb">
              <button
  type="button"
  className="ek jk lk gh gi hi rg ml il vc _d _l"
  onClick={() => {
    setFormType("Email Marketing Page");
    openModal(true); // or scroll to form if no modal
  }}
>
 Lets Connect 
</button>
          </div>
         </motion.section>
        </div>
      </div>

    </section>


  <section className="i pg qh rm ji hp relative bgblue">
     
          <motion.section
            initial={{ opacity: 0, y: 100 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: false, amount: 0.3 }} // 👈 play every time visible
            transition={{
              duration: 1.8,
              ease: "easeOut",
              type: "spring",
              stiffness: 40,
              damping: 20,
            }}
          >
     <div className="bb ze i va ki xn">
      <div className="tc uf sn tn xf un gg">
        <h3 className="fk vj wm bb _bjutfy1">What Makes Us Different: Email Marketing Built for Measurable Growth</h3>
      </div>
            <p className="jutfy1 ob">At the core of our email marketing strategy is a commitment to driving measurable, data-backed results — not just sending messages.
              <br/> We go beyond generic campaigns to deliver personalized, performance-driven email marketing that aligns with your business goals and fuels long-term growth. </p>
 <center>
     <button
  type="button"
 className="centbtn ek jk lk gh gi hi rg ml il vc _d _l"
  onClick={() => {
    setFormType("Email Marketing Page");
    openModal(true); // or scroll to form if no modal
  }}
>
  Contact Now 
</button>
</center>
    </div>
      </motion.section>
      
    </section>
 
     <div className="bb ze i va ki xn jb">
            <motion.section
                 variants={containerVariants}
                 initial="hidden"
                 whileInView="visible"
                 viewport={{ once: false, amount: 0.3 }}
               >
            <div className="wc qf pn xo gg cp">
         
                <motion.div variants={itemVariants("left")} className="animate_top rj divstyabt">
                
                <h4 className="ek yj mk2 gb">Strategy First, Always</h4>
                <p className="hdse">We begin every engagement with a deep dive into your brand, audience, and objectives. Our team builds a custom strategy rooted in segmentation, lifecycle mapping, and behavior-based triggers — ensuring each message reaches the right person, at the right time, with the right intent.</p>
                </motion.div>
    
               <motion.div variants={itemVariants("left")} className="animate_top rj divstyabt">
                
                <h4 className="ek yj mk2 gb">Data-Driven Personalization </h4>
                <p className="hdse">We harness customer data to create highly targeted and relevant experiences, not one-size-fits-all content. From dynamic content blocks to predictive send times, our approach uses personalization to drive engagement, conversions, and loyalty.</p>
             </motion.div>
    
               <motion.div variants={itemVariants("left")} className="animate_top rj divstyabt">
               
                <h4 className="ek yj mk2 gb">Full-Funnel Focus</h4>
                <p className="hdse">Unlike traditional email agencies, we optimize for the entire customer journey — from acquisition to retention and beyond. We integrate email seamlessly into your broader marketing funnel to support lead nurturing, on boarding, upselling, and reactivation.</p>
           </motion.div>
            </div>  
                <br/>
                
            <div className="wc qf pn pn gg cp">
              
               <motion.div variants={itemVariants("left")} className="animate_top rj divstyabt">
                
                <h4 className="ek yj mk2 gb">Advanced Testing & Optimization</h4>
                <p className="hdse">Growth is never static. We use continuous A/B testing, real-time analytics, and cohort analysis to refine subject lines, calls to action, design elements, and timing — constantly improving performance with every send.</p>
             </motion.div>
    
              <motion.div variants={itemVariants("left")} className="animate_top rj divstyabt">
                
                <h4 className="ek yj mk2 gb">Results That Matter</h4>
                <p className="hdse">We don't just track opens and clicks. Our success metrics are aligned with your business KPIs — such as customer lifetime value, conversion rates, and revenue attribution. Every campaign is designed to show impact where it counts.</p>
              </motion.div>
            
            </div>
            </motion.section>
          </div>
   <br/>
            <section className="i pg qh rm ji hp relative bgblue">

      {/* Stats Section */}
          <motion.section
        initial={{ opacity: 0, y: 50 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.2 }}
        transition={{ duration: 0.8 }}
      >
     <div className="bb ze i va ki xn">
      <div className="tc uf sn tn xf un gg">
        <h3 className="fk vj wm bb _b">Driving Result-Oriented Success in Your ABM Campaigns with Our Email Marketing Solution</h3>
      </div>
            <p className="jutfy1 ob">Account-Based Marketing requires precision, personalization, and alignment across multiple touchpoints to engage high-value targets effectively. Our email marketing solution is uniquely designed to support and amplify your ABM initiatives by delivering hyper-targeted, scalable, and measurable campaigns that nurture relationships and accelerate conversions.</p>
    </div>
    
      </motion.section>
      <br/>
        <center>
            <button
  type="button"
 className="centbtn ek jk lk gh gi hi rg ml il vc _d _l"
  onClick={() => {
    setFormType("Email Marketing Page");
    openModal(true); // or scroll to form if no modal
  }}
>
  Contact Now 
</button></center>
    </section>
     {/* <div className="bb ze i va ki xn jb">
               <motion.section
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8 }}
          >
            <div className="wc qf pn xo gg cp">
         
              <div className="animate_top rj divstyabt">
                
                <h4 className="ek yj mk2 gb">Targeted Messaging for High-Value Accounts </h4>
                <p className="hdse">We leverage detailed account insights and intent data to craft customized email content tailored to each target account. This ensures your messages resonate deeply with the specific pain points and priorities of key decision-makers, increasing relevance and engagement.</p>
              </div>
    
               <div className="animate_top rj divstyabt">
               
                <h4 className="ek yj mk2 gb">Personalized Sequences Aligned with Buyer Journeys </h4>
                <p className="hdse">Our solution enables the creation of multi-step, behavior-triggered email sequences that adapt based on how prospects within each account interact with your content. This dynamic personalization keeps your brand top-of-mind and guides decision-makers smoothly through the buying process.</p>
              </div>
    
               <div className="animate_top rj divstyabt">
                
                <h4 className="ek yj mk2 gb">Seamless Integration with ABM Platforms </h4>
                <p className="hdse">We integrate with leading ABM tools and CRMs to ensure consistent data flow and campaign coordination. This connectivity enables precise targeting, efficient list management, and consolidated performance tracking — all critical for ABM success.</p>
              </div>
              
            </div>  
            </motion.section>
                <br/>
                  <motion.section
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.8 }}
          >
            <div className="wc qf pn xo gg cp">
              
               <div className="animate_top rj divstyabt">
                
                <h4 className="ek yj mk2 gb">Enhanced Engagement Through Multi-Channel Coordination </h4>
                <p className="hdse">Our email campaigns work in tandem with other ABM channels—such as direct mail, social, and events—to create a cohesive and compelling account experience. By reinforcing messaging across touchpoints, we help deepen relationships and accelerate pipeline velocity.</p>
              </div>
    
              <div className="animate_top rj divstyabt">
               
                <h4 className="ek yj mk2 gb">Measurable Impact on Pipeline and Revenue </h4>
                <p className="hdse">With advanced analytics and attribution models, our solution tracks how email efforts contribute to account engagement, meetings booked, pipeline creation, and closed deals. This transparency allows you to optimize campaigns continuously and demonstrate clear ROI from your ABM investments.</p>
              </div>
            
            </div></motion.section>
          </div> */}
   <br/>
    </main>
      <Footer />
    </div>
  );
}

export default Tofuemail;
